import React, { Fragment, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import Avatar from 'react-avatar';
import { Dropdown, Navbar } from 'react-bootstrap';
import { MessageIconBlack, MessageIconBlue, logo, user } from '../../constants/images';
import routes from '../../constants/routes';
import { getHeaderCount } from '../../store/candidate/actions';
import { logOut } from '../../store/auth/actions';
import CustomToolTip from './CustomToolTip';
import { useSocket } from '../../contexts/SocketContext';

function Header(props) {
  const navigate = useNavigate();

  const { getHeaderCount, user, headerCount, candidateProfile } = props;

  const onLogOut = () => {
    const { logOut } = props;
    logOut();
    navigate(routes.login);
  };

  return (
    <Fragment>
      {!user.isAuthenticated && <PublicHeader />}
      {user.isAuthenticated && (
        <CandidateHeader
          logOut={onLogOut}
          navigate={navigate}
          getHeaderCount={getHeaderCount}
          headerCount={headerCount}
          user={user.currentUser}
          image={
            candidateProfile && candidateProfile?.profile.image
              ? candidateProfile?.imageurl + candidateProfile?.profile.image
              : null
          }
        />
      )}
    </Fragment>
  );
}

function PublicHeader(props) {
  const { pathname } = useLocation();
  return (
    <div className="nav-bar position-sticky top-0 bg-white border-bottom">
      <div className="container-fluid">
        <Navbar expand="lg">
          <div className="container-fluid">
            <a className="navbar-brand me-5" href={routes.home}>
              <img src={logo} alt="VeriiPro Logo" className="logo pe-none" />
            </a>
            <Navbar.Toggle className="shadow-none me-0" aria-controls="basic-navbar-nav" />
            <Navbar.Collapse className="nav-bar-a" id="navbarSupportedContent">
              <ul className="navbar-nav me-auto d-lg-flex align-items-lg-center">
                <li className="nav-item me-3">
                  <Link
                    className="nav-link text-dark text-uppercase fw-500"
                    aria-current="page"
                    to={routes.about}>
                    about us
                  </Link>
                </li>
                <li className="nav-item me-3">
                  <Link className="nav-link text-dark text-uppercase fw-500" to={routes.jobs}>
                    jobs
                  </Link>
                </li>
                <li className="nav-item me-3">
                  <a href={routes.blog} className="nav-link text-dark text-uppercase fw-500">
                    blog
                  </a>
                </li>
              </ul>
              <ul className="navbar-nav ms-auto d-lg-flex align-items-lg-center">
                <li className="nav-item me-3 my-lg-0 my-2 d-flex">
                  <Link
                    className={`btn-login ${
                      pathname.includes(routes.login) ? 'btn-login-active' : ''
                    }`}
                    to={routes.login}>
                    job seeker login
                  </Link>
                </li>
                <li className="nav-item me-3 my-lg-0 my-2 d-flex">
                  <Link
                    className={`btn-lightblue text-uppercase ${
                      !pathname.includes(routes.login) ? 'btn-lightblue-active' : ''
                    }`}
                    to={routes.register}>
                    sign up
                  </Link>
                </li>
                <Dropdown variant="link" className="nav-item dropdown d-flex">
                  <a className="btn-login-dropdown" href={routes.employerHome}>
                    <img src={user} alt="User Icon" className="icon-size me-2 pe-none" />
                    Employers
                  </a>
                  <Dropdown.Toggle
                    split
                    className="nav-link dropdown-toggle bg-light justify-content-center d-flex align-items-center border-0 rounded-0"
                  />
                  <Dropdown.Menu className="border-0 rounded-3 shadow mt-2 position-absolute">
                    <Link
                      className="dropdown-item text-capitalize fw-500 text-secondary"
                      to={routes.employerLogin}>
                      Login
                    </Link>
                    <Link
                      className="dropdown-item text-capitalize fw-500 text-secondary"
                      to={routes.employerHome}>
                      Register Account
                    </Link>
                  </Dropdown.Menu>
                </Dropdown>
              </ul>
            </Navbar.Collapse>
          </div>
        </Navbar>
      </div>
    </div>
  );
}

function CandidateHeader(props) {
  const { totalUnreadCount } = useSocket();
  const { getHeaderCount } = props;
  useEffect(() => {
    async function fetchData() {
      await getHeaderCount();
    }
    fetchData();
  }, []);

  const { user, image, headerCount } = props;

  const MessageNotification = () => {
    return (
      <ul className="navbar-nav ms-auto mb-lg-0 login-signup-btn align-items-lg-center">
        <CustomToolTip
          text={`You have ${totalUnreadCount ?? 0} unread messages`}
          placement="bottom">
          <Link className="me-3 mt-1 position-relative cursor-pointer" to={routes.viewMessages}>
            <div className="text-dark text-uppercase fw-500 ">
              <img
                src={MessageIconBlack}
                alt="messages"
                className="message-icon"
                onMouseOver={(e) => (e.target.src = MessageIconBlue)}
                onMouseOut={(e) => (e.target.src = MessageIconBlack)}
              />
              <div className="notification-count">
                {totalUnreadCount > 0 && (
                  <span className="message-count">
                    {totalUnreadCount > 99 ? '+99' : totalUnreadCount}
                  </span>
                )}
              </div>
            </div>
          </Link>
        </CustomToolTip>
      </ul>
    );
  };

  return (
    <React.Fragment>
      <div className="nav-bar position-sticky top-0 bg-white border-bottom">
        <div className="container">
          <Navbar className="py-lg-0" expand="lg">
            <div className="container-fluid">
              <Link className="navbar-brand me-5" to={routes.dashboard}>
                <img src={logo} alt="VeriiPro Logo" className="logo pe-none" />
              </Link>
              <div className="ms-auto mx-2 d-lg-none">{MessageNotification()}</div>
              <Navbar.Toggle className="shadow-none" aria-controls="basic-navbar-nav" />
              <Navbar.Collapse className="nav-bar-a" id="navbarSupportedContent">
                <ul className="navbar-nav me-auto mb-lg-0 align-items-lg-center">
                  <li className="nav-item me-3">
                    <Link
                      className="nav-link text-dark text-uppercase fw-500"
                      to={routes.searchJob}>
                      SEARCH JOBS
                    </Link>
                  </li>
                  <li className="nav-item me-3 position-relative">
                    <Link
                      className="nav-link text-dark text-uppercase fw-500"
                      to={routes.appliedJob}>
                      Applied Jobs
                      {headerCount?.appliedCount > 0 && (
                        <span className="header-count">{headerCount?.appliedCount}</span>
                      )}
                    </Link>
                  </li>
                  <li className="nav-item me-3 position-relative">
                    <Link className="nav-link text-dark text-uppercase fw-500" to={routes.savedJob}>
                      Saved Jobs
                      {headerCount?.savedCount > 0 && (
                        <span className="header-count">{headerCount?.savedCount}</span>
                      )}
                    </Link>
                  </li>
                </ul>
                <ul className="navbar-nav ms-auto mb-lg-0 login-signup-btn align-items-lg-center">
                  <div className="d-none d-lg-block">{MessageNotification()}</div>
                  <Dropdown variant="link" className="nav-item dropdown ">
                    <Dropdown.Toggle
                      variant="link"
                      className="nav-link dropdown-toggle text-uppercase text-dark d-flex align-items-center fw-500"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false">
                      <Avatar
                        size="50"
                        name={`${user.first_name} ${user.last_name}`}
                        src={
                          image
                            ? image
                            : 'https://app.veriipro.com/images/profile-picture-blank.png'
                        }
                        alt="User Icon"
                        className="userprofile me-2 rounded-pill"
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="dropdown-menu rounded-3 border-0 shadow mt-0">
                      <Dropdown.Item as="div" className="mb-2">
                        <Link
                          className="text-capitalize text-decoration-none fw-500 text-secondary"
                          to={routes.profile}>
                          My Profile
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item as="div" className="mb-2">
                        <Link
                          className="text-capitalize text-decoration-none fw-500 text-secondary"
                          to={routes.jobAlert}>
                          Job Alerts
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item as="div" className="mb-2">
                        <Link
                          className="text-capitalize text-decoration-none fw-500 text-secondary"
                          to={routes.changePassword}>
                          Settings
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item as="div" className="mb-2">
                        <Link
                          className="text-capitalize text-decoration-none fw-500 text-secondary"
                          to={routes.viewMessages}>
                          Messages
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item as="div" className="mb-2">
                        <Link
                          className="text-capitalize text-decoration-none fw-500 text-secondary"
                          to={routes.contact}>
                          Contact Us
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item
                        as="div"
                        className="dropdown-item text-capitalize text-blue fw-600 cursor"
                        onClick={props.logOut}>
                        Log Out
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </ul>
              </Navbar.Collapse>
            </div>
          </Navbar>
        </div>
      </div>
    </React.Fragment>
  );
}

export default connect(
  (state) => ({
    user: state.auth,
    candidateProfile: state.candidate.profile,
    headerCount: state.candidate.headerData
  }),
  {
    logOut,
    getHeaderCount
  }
)(Header);
